var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{attrs:{"logo":"/img/brand/brand.svg","background-color":"blue"},scopedSlots:_vm._u([{key:"links",fn:function(props){return [_c('sidebar-item',{attrs:{"link":{
          name: 'Companies',
          path: '/companies',
          icon: 'ni ni-shop text-primary',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'New Company',
          path: '/companies/create',
          icon: 'ni ni-fat-add text-success',
        }}}),(_vm.account)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.account.name,
          icon: 'ni ni-briefcase-24 text-info',
          classes: 'ellipsis',
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Manage account',
            path: '/account',
            icon: 'ni ni-settings text-primary',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Switch account',
            path: '/select-account',
            icon: 'fa fa-random text-primary',
          }}})],1):_vm._e()]}}])},[_c('template',{slot:"links-after"},[_c('hr',{staticClass:"my-3"}),_c('b-nav',{staticClass:"navbar-nav mb-md-3"},[_c('b-nav-item',{attrs:{"href":"mailto:support@adminhero.co"}},[_c('i',{staticClass:"ni ni-spaceship"}),_c('b-nav-text',{staticClass:"p-0"},[_vm._v("Support")])],1),_c('b-nav-item',{attrs:{"href":"https://adminhero.co"}},[_c('i',{staticClass:"ni ni-palette"}),_c('b-nav-text',{staticClass:"p-0"},[_vm._v("About")])],1)],1)],1)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar'),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }